import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import ListItem from './ListItem';

/* 예약자 정보 display section - used inside Card across:
   ReservationDetail, TransferComplete, TourComplete, TransferPayment, TourPayment
   variant: 'default' (service pages), 'admin' (admin detail pages) */
function formatPhone(phone) {
  if (!phone) return phone;
  const cleaned = phone.replace(/[^\d+]/g, '');
  // 한국 번호(+82) → 010-XXXX-XXXX 로컬 포맷
  if (cleaned.startsWith('+82')) {
    let num = '0' + cleaned.slice(3);
    if (num.length > 11) num = num.slice(0, 11);
    if (/^(01[016789])(\d{4})(\d{4})$/.test(num)) return num.replace(/^(01[016789])(\d{4})(\d{4})$/, '$1-$2-$3');
    if (/^(01[016789])(\d{3})(\d{4})$/.test(num)) return num.replace(/^(01[016789])(\d{3})(\d{4})$/, '$1-$2-$3');
    return num;
  }
  // 비한국 E.164 (+81 JP 등) → 국제 표기 (예: +81 234 234 324)
  if (cleaned.startsWith('+')) return formatPhoneNumberIntl(cleaned) || cleaned;
  // prefix 없는 raw 로컬 KR (legacy 데이터)
  let num = cleaned;
  if (num.length > 11 && num.startsWith('01')) num = num.slice(0, 11);
  if (/^(01[016789])(\d{4})(\d{4})$/.test(num)) return num.replace(/^(01[016789])(\d{4})(\d{4})$/, '$1-$2-$3');
  if (/^(01[016789])(\d{3})(\d{4})$/.test(num)) return num.replace(/^(01[016789])(\d{3})(\d{4})$/, '$1-$2-$3');
  return num;
}

export default function GuestInfoSection({ name, phone, email, membership, variant = 'default' }) {
  const { t } = useTranslation();
  const isAdmin = variant === 'admin';
  const itemLayout = isAdmin ? 'admin' : 'inline';
  // 어드민은 한국 운영자 전용 → 라벨은 항상 한국어 (브라우저 lang=en 무시)
  const L = isAdmin ? {
    title: '예약자 정보',
    name: '이용자명',
    phone: '연락처',
    email: '이메일',
  } : {
    title: t('common.guest_info_title'),
    name: t('common.user_name_label'),
    phone: t('common.phone_label_short'),
    email: t('common.email_label_short'),
  };
  return (
    <>
      <h3 className="text-lg font-bold text-mono-900">{L.title}</h3>
      <div className="flex flex-col">
        <ListItem label={L.name} value={name} extra={membership} layout={itemLayout} />
        <ListItem label={L.phone} value={formatPhone(phone)} layout={itemLayout} />
        <ListItem label={L.email} value={email} layout={itemLayout} />
      </div>
    </>
  );
}
